import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IrbClientsService } from '@irb/irb-clients/irb-clients.service';
import { IAccount } from '@irb/irb-clients/irb-clients.model';
import { IDropdownItem } from '@irb-common/models/dropdown.model';
import { UtilityService } from "@irb-common/services/utility.service";
import {AssignAccountsToPortfolioDialogGridLayoutService} from "@irb/irb-clients/assign-accounts-to-portfolio-dialog/assign-accounts-to-portfolio-dialog.grid-layout.service";
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({ standalone: false,
  selector: 'irb-assign-accounts-to-portfolio-dialog',
  templateUrl: './assign-accounts-to-portfolio-dialog.component.html',
  styleUrls: ['./assign-accounts-to-portfolio-dialog.component.scss']
})
export class AssignAccountsToPortfolioDialogComponent implements OnInit {
  @ViewChild('portfolioDropdown') portfolioDropdown: any;
  portfolioTarget: IDropdownItem;
  portfolioAccounts: Array<IAccount> = [];
  grid: any;
  gridOptions: any;
  
  constructor(
    public dialogRef: MatDialogRef<AssignAccountsToPortfolioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any,
    private cs: IrbClientsService,
    private util: UtilityService,
    private gls: AssignAccountsToPortfolioDialogGridLayoutService,
    private ats: AnalyticsService
  ) { }

  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };

    this.portfolioAccounts = this.mdd.portfolioAccounts as Array<IAccount>;
  }

  close() {
    this.dialogRef.close();
  }
  onGridReady(params: any) {
    this.grid = params;
  }
  assignAccounts() {
      this.mdd.callBack(this.portfolioTarget.value, this.portfolioTarget.name);
    this.close();
  }

  createNewPortfolio() {
    this.ats.trackClickEvent("lc_newhouse");
    this.mdd.callBack();
    this.close();
  }

  setPortfolioTarget(value: any) {
    this.portfolioTarget = value;
  }

  getPortfolios(searchStr: any) {
    const sortByKey = this.util.sortByKey;

    this.cs.getPortDropDown(searchStr).subscribe((data: any) => {
      sortByKey(data.items, "name");
      this.portfolioDropdown.set(data.items);
    });
  }
}
